import React from 'react';

import UsersList from './Users';

const Admin: React.FunctionComponent = () => <UsersList />;

export default Admin;
